// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Drhc","field":"styles_field__16oHq","fieldCol":"styles_fieldCol__2-qen","diffCol":"styles_diffCol__2bIzJ","diff":"styles_diff__1i94k"};